export default __webpack_public_path__ + "static/media/csvIcon.bd5ee057.png";